var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verified_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3329",
    "data-name": "Rectangle 3329",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M23,12,20.56,9.21l.34-3.69L17.29,4.7,15.4,1.5,12,2.96,8.6,1.5,6.71,4.69,3.1,5.5l.34,3.7L1,12l2.44,2.79-.34,3.7,3.61.82L8.6,22.5,12,21.03l3.4,1.46,1.89-3.19,3.61-.82-.34-3.69ZM10.09,16.72l-3.8-3.81,1.48-1.48,2.32,2.33,5.85-5.87,1.48,1.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/approvals.1f6377032a708bd7c3a4f2551813796c.svg";
export { ForwardRef as ReactComponent };